/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_Template_CreatedInputs */



/**
* | output |
* | --- |
* | "New event template created" |
*
* @param {Context_Menu_Event_Template_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_template_created = /** @type {((inputs?: Context_Menu_Event_Template_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_Template_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau modèle d'événement créé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Ereignisvorlage erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo modello di evento creato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создан новый шаблон мероприятия.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva plantilla de evento creada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建了新的活动模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいイベントテンプレートが作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया इवेंट टेम्प्लेट बनाया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo modelo de evento criado")
	return /** @type {LocalizedString} */ ("New event template created")
});